import { createAction } from 'typesafe-actions';
export const setFullAppFlow = createAction('SET_FULL_APP_FLOW', (isFullAppFlow: boolean) => isFullAppFlow)();

export const setShowFullAppExitModal = createAction('SET_SHOW_FULLAPP_EXIT_MODAL', (isShowExitModal: boolean) => isShowExitModal)();
